<app-menu [menuModuleEnum]="menuModuleEnum"></app-menu>
<div class="container-body">
    <div class="white-body">
        <div class="title-header">
            <mat-icon aria-hidden="false" aria-label="Menu apps">manage_accounts</mat-icon> 
            <h1>Bem vindo(a) a plataforma ToLife</h1>
        </div>
        <p>Selecione o modulo que você deseja atuar no menu e aproveite nossas funcionalidades!</p>
    </div>
</div>